// @Version: 1.0.0
import { Injectable } from '@angular/core';
import { IImageImgText, ILinkImgText } from './img-text.model';

@Injectable({
  providedIn: 'root'
})
export class ImgTextService {

  constructor() { }

  public setImgText (text: string): IImageImgText {
    let result: IImageImgText = {} as IImageImgText;
    if (text.indexOf(";") > -1) {
      let textSplit = text.split(";");
      result.altText = textSplit[0];
      result.imgText = textSplit[1];
    } else result.altText = text;
    return result;
  }

  public setLink (ls: string): ILinkImgText {
    let result: ILinkImgText = {} as ILinkImgText;
    let lsSplit = ls.split(";");
    lsSplit.length > 1 ? result = {src: lsSplit[0], filename: lsSplit[1]} : result.src = lsSplit[0];
    return result;
  }

}
